import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SerializedSettingsEntity } from './models/settings-entity';

@Injectable()
export abstract class UserSettingsRepository {
  abstract saveSettings(settings: SerializedSettingsEntity[]): Observable<SerializedSettingsEntity[]>;
}
